import { memo } from "react";

import { QuestionStayableDayOfTheWeek } from "@/components/features/items/edit/_shared/ui/components/main/questions/stayable-day-of-the-week/stayable-day-of-the-week";

import { usePlanStayableDayOfTheWeek } from "./hooks";

export const QuestionPlanStayableDayOfTheWeek = memo(() => {
	const {
		stayableDayOfTheWeek,
		rawStayableDayOfTheWeek,
		onSetStayableDayOfTheWeek,
		stayableDayOfTheWeekOptions,
		isHolidayStayable,
		onSetIsHolidayStayable,
	} = usePlanStayableDayOfTheWeek();

	return (
		<QuestionStayableDayOfTheWeek
			stayableDayOfTheWeekOptions={stayableDayOfTheWeekOptions}
			stayableDayOfTheWeek={stayableDayOfTheWeek}
			rawStayableDayOfTheWeek={rawStayableDayOfTheWeek}
			onSetStayableDayOfTheWeek={onSetStayableDayOfTheWeek}
			isHolidayStayable={isHolidayStayable}
			onSetIsHolidayStayable={onSetIsHolidayStayable}
		/>
	);
});

QuestionPlanStayableDayOfTheWeek.displayName = "QuestionPlanStayableDayOfTheWeek";
